export default __webpack_public_path__ + "static/media/9.72b54e5b.PNG";